import apiClient from "./client";
import type {
  LicenseCustomer,
  LicenseCustomerForm,
  ApiResponse,
  ListResponse,
} from "@/types";

const BASE = "/customers";

export interface CustomerQueryParams {
  page?: number;
  page_size?: number;
  search?: string;
  logic?: "and" | "or";
  id?: number;
  name?: string;
  contact_name?: string;
  company?: string;
  created_at_start?: string;
  created_at_end?: string;
}

export async function listCustomers(
  params?: CustomerQueryParams,
): Promise<ApiResponse<ListResponse<LicenseCustomer>>> {
  const { data } = await apiClient.get(BASE, { params });
  return data;
}

export async function getCustomer(
  id: number,
): Promise<ApiResponse<LicenseCustomer>> {
  const { data } = await apiClient.get(`${BASE}/${id}`);
  return data;
}

export async function createCustomer(
  form: LicenseCustomerForm,
): Promise<ApiResponse<LicenseCustomer>> {
  const { data } = await apiClient.post(BASE, form);
  return data;
}

export interface CustomerBatchUpdatePayload {
  ids: number[];
  name?: string;
  contact_name?: string;
  email?: string;
  phone?: string;
  company?: string;
  notes?: string;
}

export interface CustomerBatchDeletePayload {
  ids: number[];
}

export async function updateCustomersBatch(
  data: CustomerBatchUpdatePayload,
): Promise<ApiResponse<null>> {
  const { data: result } = await apiClient.patch(BASE, data);
  return result;
}

export async function deleteCustomersBatch(
  data: CustomerBatchDeletePayload,
): Promise<ApiResponse<null>> {
  const { data: result } = await apiClient.delete(BASE, { data });
  return result;
}

export async function updateCustomer(
  id: number,
  form: Partial<LicenseCustomerForm>,
): Promise<ApiResponse<LicenseCustomer>> {
  const { data } = await apiClient.put(`${BASE}/${id}`, form);
  return data;
}

export async function deleteCustomer(id: number): Promise<ApiResponse<null>> {
  const { data } = await apiClient.delete(`${BASE}/${id}`);
  return data;
}
